import React from 'react';
import { createRoot } from 'react-dom/client'; // Use createRoot instead of render
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import * as Sentry from "@sentry/react";

// Initialize Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV || 'development',
});

// Create a root element
const container = document.getElementById('root');
const root = createRoot(container); // Create a React root

// Render the application
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
